module.exports = __webpack_public_path__ + "static/img/visitor-union.4abcc4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/visitor-union.png
// module id = /LZk
// module chunks = 9